export default __webpack_public_path__ + "static/media/BANNER04.36214679.png";